module.exports = __webpack_public_path__ + "media/site/images/contact-slider/contact_slideshow-15-8180b22719ef664d9fe640b8b447d6cf.jpg";